import { API, authClient } from "../index";

export const postPartida = async (partida, accessToken) => {
	return authClient(accessToken).post(`${API}/partidas`, partida);
};

export const getPartidas = (accessToken) => {
	return authClient(accessToken).get(`${API}/partidas`);
};

export const getPartidaById = (id, accessToken) => {
	return authClient(accessToken).get(`${API}/partidas/${id}`);
};

export const updatePartida = async (id, partida, accessToken) => {
	return authClient(accessToken).put(`${API}/partidas/${id}`, partida);
};

export const deletePartida = (id, accessToken) => {
	return authClient(accessToken).delete(`${API}/partidas/${id}`);
};
